/** Build the authenticated HELP packet endpoint without exposing a raw download URL. */
export function buildBenefitPrintPath(benefitId: string, programYear?: number): string {
  if (programYear !== undefined && (!Number.isInteger(programYear) || programYear < 1900 || programYear > 3000)) {
    throw new Error("Choose a valid print year.")
  }
  return `/api/LegacyPrinting/help/${encodeURIComponent(benefitId)}${programYear === undefined ? "" : `?programYear=${programYear}`}`
}
